import { DateTime } from 'luxon';

export const formatDateForAPI = (date: Date): string => DateTime.fromJSDate(date).toFormat('yyyy-LL-dd');

export const formatDateForChart = (date: Date | string | number): Date => {
  let dateObj: Date;

  if (typeof date === 'number') {
    dateObj = new Date(date);
  } else if (typeof date === 'string') {
    dateObj = new Date(date);
  } else {
    dateObj = date;
  }

  return new Date(dateObj.getFullYear(), dateObj.getMonth(), dateObj.getDate());
};
